import React, { useState } from 'react';
import { Select, Space, Form, Button, Tag, Modal, List, Tooltip } from 'antd';
import { EditOutlined, InfoCircleOutlined } from '@ant-design/icons';
import { updateScopeApis } from '../../apis/apis';

const { Option } = Select;

const scopeMessage = "Just user has at least one of below scope can access this api."

export const Description = ({ options, handleClose, visible }) => {
  return (
    <Modal
      title="API SCOPE DETAILS" visible={visible} onCancel={handleClose}
      okButtonProps={{
        style: {
          display: 'none'
        }
      }}
      cancelText="Close"
    >
      <List
        header="API SCOPE REFERENCE"
        bordered
        size="small"
        dataSource={options || []}
        renderItem={item => {
          return (
            (
              <List.Item>
                <span><Tag color="default">{item.id}</Tag> {item?.description || ''}</span>
              </List.Item>
            )
          )
        }}
      />
    </Modal>
  )
}


const MultiSelect = ({
  labelStyle,
  contentStyle,
  value,
  options,
  onSubmit
}) => {
  const [form] = Form.useForm();
  const [isEditable, setIsEditable] = useState(false);
  const [openModal, setOpenModal] = useState(false);

  const handletoggle = () => {
    setIsEditable((pre) => !pre);
  }

  const handleSumit = async () => {
    const { 'scope-select': scopeSelected } = form.getFieldsValue();
    if (onSubmit) {
      await onSubmit(scopeSelected);
    }
    setIsEditable(false);
  }

  const handleClose = () => {
    setIsEditable(false);
    form.setFields([{
      name: 'scope-select',
      value: value
    }]);
  }

  const renderLabel = () => {
    return (
      <p style={{ ...labelStyle, marginBottom: 0 }}>
        Scope:{' '}
        {/* <span>
          <InfoCircleOutlined
            style={{
              color: 'rgb(26, 148, 255)',
              fontWeight: 700,
              cursor: 'pointer'
            }}
          />
        </span> */}
      </p>
    )
  }

  return (
    <div style={{ marginBottom: '1em' }}>
      {
        !isEditable &&
        (
          <div>
            <div style={{ marginBottom: '0.5em' }}>
              {renderLabel()}
              <div
                style={{
                  fontSize: 14,
                  color: 'grey',
                  fontStyle: 'italic'
                }}
              >{scopeMessage}
                <a href=""
                  onClick={(e) => {
                    e.preventDefault();
                    setOpenModal(true)
                  }}
                >
                  Please read the reference table for details
                </a>
              </div>
            </div>
            <Space style={{ alignItems: 'flex-start' }}>
              {/* <p style={labelStyle}>Scope:</p> */}
              <div style={{ marginBottom: '1em', maxWidth: 300 }}>
                {
                  value && (
                    value.length > 0 ? (
                      value && value.map((item) => {
                        const foundItem = options.find((option) => option.id === item);
                        return (
                          (
                            <Tag color="default" style={{ marginBottom: 3 }} key={item}>
                              <span>{item} - {foundItem?.name || ''}</span>
                            </Tag>
                          )
                        )
                      })
                    ) : (
                      <Select
                        mode="multiple"
                        allowClear={false}
                        style={{ minWidth: '300px' }}
                        placeholder={'Please select scope'}
                        defaultValue={value}
                        disabled={true}
                        optionLabelProp="value"
                      >
                        {options && options.map((option) => {
                          return (
                            <Option key={option.id} value={option.id} >
                              <b>{option.id}</b> - {option.name}
                            </Option>
                          )
                        })}
                      </Select>
                    )
                  )

                }
              </div>
              <span
                onClick={handletoggle}
                style={{
                  marginLeft: 15,
                  color: 'rgb(26, 148, 255)',
                  fontWeight: 700,
                  cursor: 'pointer',
                  marginBottom: '1em',
                  display: 'inline-block',
                  fontSize: 16
                }}>
                <EditOutlined />
              </span>
            </Space>
          </div>
        )
      }
      {
        isEditable && (
          <div>
            <div style={{ marginBottom: '1em' }}>
              {renderLabel()}
              <div
                style={{
                  fontSize: 14,
                  color: 'grey',
                  fontStyle: 'italic'
                }}
              >{scopeMessage}
                <a href=""
                  onClick={(e) => {
                    e.preventDefault();
                    setOpenModal(true)
                  }}
                >
                  Please read the reference table for details
                </a>
              </div>
            </div>
            <Space>
              <div style={{ marginBottom: '1em' }}>
                <Space>
                  <Form name="form-scope" onFinish={handleSumit} form={form}>
                    <Space>
                      <Form.Item name="scope-select" noStyle={true}>
                        <Select
                          mode="multiple"
                          allowClear={false}
                          style={{ minWidth: '300px' }}
                          placeholder={isEditable ? 'Please select scope' : ''}
                          defaultValue={value}
                          disabled={!isEditable}
                          optionLabelProp="value"
                        >
                          {options && options.map((option) => {
                            return (
                              <Option key={option.id} value={option.id} >
                                <b>{option.id}</b> - {option.name}
                              </Option>
                            )
                          })}
                        </Select>
                      </Form.Item>
                      {
                        isEditable && (
                          <>
                            <Button htmlType="submit" size="small" type="primary">Save</Button>
                            <Button onClick={handleClose} size="small">Cancel</Button>
                          </>
                        )
                      }
                    </Space>
                  </Form>
                </Space>
                <br />
              </div>
            </Space>
          </div>
        )
      }
      <Description
        visible={openModal}
        options={options}
        handleClose={() => {
          setOpenModal(false)
        }}
      />
    </div>
  )
}

export default MultiSelect